import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findBankCardList= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_bank?`+params,
        method: 'GET'
    })
}
export const addBankCard= (data) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_bank`,
        method: 'POST',
        data: data
    })
}
export const editBankCard= (data) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_bank`,
        method: 'PUT',
        data: data
    })
}
export const delBankCard = (id) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_bank/${id}`,
        method: 'DELETE'
    })
}
export const findBankCard= () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_bank/select`,
        method: 'GET'
    })
}